/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { RefusalReasonType } from './';
import {
    RefusalReasonTypeFromJSON,
    RefusalReasonTypeFromJSONTyped,
    RefusalReasonTypeToJSON,
} from './';

/**
 * 
 * @export
 * @interface DocumentRejectionRequest
 */
export interface DocumentRejectionRequest {
    /**
     * 
     * @type {RefusalReasonType}
     * @memberof DocumentRejectionRequest
     */
    refusalReasonType: RefusalReasonType;
    /**
     * Optional details for custom refusal reasons (especially when refusalReasonType is OTHER)
     * @type {string}
     * @memberof DocumentRejectionRequest
     */
    details?: string;
    /**
     * Optional message sent to the freelancer in the refusal email body (only used when refusalReasonType is OTHER)
     * @type {string}
     * @memberof DocumentRejectionRequest
     */
    refusalEmailContent?: string;
}

/**
 * Check if a given object implements the DocumentRejectionRequest interface.
 */
export function instanceOfDocumentRejectionRequest(value: object): value is DocumentRejectionRequest {
    if (!('refusalReasonType' in value) || value['refusalReasonType'] === undefined) return false;
    return true;
}

export function DocumentRejectionRequestFromJSON(json: any): DocumentRejectionRequest {
    return DocumentRejectionRequestFromJSONTyped(json, false);
}

export function DocumentRejectionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): DocumentRejectionRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'refusalReasonType': RefusalReasonTypeFromJSON(json['refusalReasonType']),
        'details': json['details'] == null ? undefined : json['details'],
        'refusalEmailContent': json['refusalEmailContent'] == null ? undefined : json['refusalEmailContent'],
    };
}

export function DocumentRejectionRequestToJSON(value?: DocumentRejectionRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'refusalReasonType': RefusalReasonTypeToJSON(value['refusalReasonType']),
        'details': value['details'],
        'refusalEmailContent': value['refusalEmailContent'],
    };
}

